export default __webpack_public_path__ + "static/media/Food-min.6a9b8d74.png";